// Mock data for VivaDecor interior design website

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'Contact', href: '#contact' },
  { label: 'Support', href: '#support' },
];

export const stats = [
  { value: '400+', label: 'Project Complete' },
  { value: '600+', label: 'Satisfied Clients' },
  { value: '100+', label: 'Unique Styles' },
];

export const services = [
  {
    icon: 'Lamp',
    title: 'Lighting Design',
    description:
      'Achieve the perfect balance of illumination and ambiance with our expertly curated lighting solutions tailored to highlight every detail of your space.',
  },
  {
    icon: 'Armchair',
    title: 'Interior Design',
    description:
      'From concept to completion, we craft interiors that reflect your personality, blending timeless aesthetics with modern functionality for stunning living spaces.',
  },
  {
    icon: 'Trees',
    title: 'Outdoor Design',
    description:
      'Celebrate the changing seasons by reimagining your outdoor environments into elegant retreats that complement nature and your lifestyle effortlessly.',
  },
  {
    icon: 'PaintBucket',
    title: 'Color Consultation',
    description:
      'Discover palettes that breathe life into every room. Our color experts harmonize tones to evoke mood, light, and depth across all surfaces.',
  },
  {
    icon: 'Sofa',
    title: 'Furniture Selection',
    description:
      'Curated furniture choices crafted to fit your vision, comfort, and style — combining quality, character, and contemporary craftsmanship.',
  },
  {
    icon: 'Home',
    title: 'Space Planning',
    description:
      'Maximize the potential of every square foot with intelligent layouts engineered to enhance flow, function, and visual harmony.',
  },
];

export const accordionItems = [
  {
    id: 'living-room',
    title: 'Living Room Interior Design',
    content:
      'Transform your living room into a sanctuary of comfort and style. Our designers blend luxurious textures, warm lighting, and curated furniture pieces to create a space that welcomes guests and nurtures everyday moments.',
  },
  {
    id: 'commercial-office',
    title: 'Commercial Office Room Interior Design',
    content:
      'Elevate productivity and brand identity through thoughtful office interiors. We combine ergonomic principles with sophisticated aesthetics to inspire creativity, collaboration, and a professional atmosphere.',
  },
  {
    id: 'bedroom',
    title: 'Bedroom Interior Design',
    content:
      'Craft a serene retreat where rest meets refinement. From layered fabrics to personalized lighting, every detail is curated to complement your lifestyle and promote restful tranquility.',
  },
  {
    id: 'kitchen',
    title: 'Kitchen Interior Design',
    content:
      'Where culinary art meets thoughtful design — explore custom cabinetry, premium finishes, and intelligent layouts that turn cooking into an inspiring daily ritual.',
  },
  {
    id: 'bathroom',
    title: 'Bathroom Interior Design',
    content:
      'Design spa-like sanctuaries with premium fixtures, calming materials, and seamless layouts that turn ordinary routines into rejuvenating experiences.',
  },
];

export const designSteps = [
  {
    id: 1,
    icon: 'Rocket',
    title: 'Start Project',
    description:
      'Embark on your design adventure by initiating your project. Share your vision and set the stage for a bespoke design experience.',
  },
  {
    id: 2,
    icon: 'Compass',
    title: 'Craft',
    description:
      'Collaborate closely to achieve design excellence refining your vision and crafting brilliance into every aspect of your space.',
  },
  {
    id: 3,
    icon: 'CheckCircle2',
    title: 'Execute',
    description:
      'Witness your vision becoming a reality as we execute the design plan with precision. Celebrate the joy of your newly transformed space.',
  },
];

export const testimonials = [
  {
    id: 1,
    quote:
      'Working with your design team was an absolute pleasure. The attention to detail and creativity exceeded my expectations. Thank you for making my home beautiful!',
  },
  {
    id: 2,
    quote:
      'Exceptional service! From the initial consultation to the final reveal, your team demonstrated professionalism and a keen eye for design. Highly recommend!',
  },
  {
    id: 3,
    quote:
      'Their team transformed our space into something we never thought possible. Every corner reflects elegance and warmth. We could not be happier with the result.',
  },
  {
    id: 4,
    quote:
      'Truly remarkable craftsmanship and creativity. Our office now feels like a place of inspiration. The transformation has been beyond expectations.',
  },
];

export const heroImages = {
  primary:
    'https://images.pexels.com/photos/6615806/pexels-photo-6615806.jpeg',
  secondary:
    'https://images.unsplash.com/photo-1583847268964-b28dc8f51f92',
};

export const sectionImages = {
  brilliance:
    'https://images.unsplash.com/photo-1705321963943-de94bb3f0dd3',
  threeSteps:
    'https://images.pexels.com/photos/34538288/pexels-photo-34538288.jpeg',
  testimonialBg:
    'https://images.unsplash.com/photo-1631679706909-1844bbd07221',
};

export const footerData = {
  brand: {
    name: 'Ashoka Interiors',
    tagline:
      'Ashoka Interiors \u2014 your premier destination for luxury and modern interior design.',
  },
  columns: [
    {
      title: 'Our Services',
      links: [
        { label: 'Interior design', href: '#' },
        { label: 'Outro design', href: '#' },
        { label: 'Lightning design', href: '#' },
        { label: 'Our Services', href: '#' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'Reviews', href: '#' },
        { label: 'Careers', href: '#' },
        { label: 'Pricing', href: '#' },
        { label: 'Press inquiries', href: '#' },
      ],
    },
  ],
  contact: {
    title: 'Contact Us',
    phone: '7008750192',
    address: 'Bhubaneswar, Odisha, India',
  },
};
